import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckMarks = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "check-marks",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.3331 18.8679L15.0578 17.1166L15.6824 17.7499L25.774 7.5L27.5 9.25007L15.6824 21.25L13.3331 18.8679ZM8.18239 17.7499L18.274 7.5L20 9.25007L8.18239 21.25L2.46709 15.4375L4.19308 13.6874L8.18239 17.7499Z",
			fill: "#007b23"
		})
	})
});
export default SvgCheckMarks;
